<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "trusted-rudra" },
    [
      _c("div", { staticClass: "upper-right-column p-2" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c("b-avatar", {
              staticClass: "badge-minimal",
              attrs: {
                size: "30",
                variant: "light-primary mr-1",
                badge: "",
                text: _vm.name[0] || "",
                "badge-variant": "success",
              },
            }),
            _vm._v(" " + _vm._s(_vm.name) + " "),
            _c(
              "div",
              { staticClass: "ml-1" },
              [
                _vm.userLevel === "GOLD" ? _c("Verify") : _vm._e(),
                _vm.userLevel === "REGULAR" ? _c("Silver") : _vm._e(),
                _vm.userLevel === "PLATINUM" ? _c("Platinum") : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {
          ref: "questionBox",
          staticClass: "msg-scrolable",
          class: { "img-uploaded": _vm.picture },
          on: { scroll: _vm.handleScroll },
        },
        _vm._l(_vm.adOrderChatList, function (item, index) {
          return _c("div", { key: index, staticClass: "scroll-msg" }, [
            item.userId !== _vm.user.id
              ? _c("div", { staticClass: "m-1" }, [
                  _c("div", [
                    _c("div", { staticClass: "d-flex" }, [
                      _c(
                        "div",
                        { staticClass: "d-inline" },
                        [
                          _c("b-avatar", {
                            staticClass: "badge-minimal mr-1 mt-1",
                            attrs: {
                              size: "30",
                              variant: "light-primary",
                              text: _vm.name[0],
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "positive-feedback d-inline p-1" },
                        [
                          _c("div", [_vm._v(_vm._s(item.message))]),
                          (item.imageUrl || item.imageDocUrl) && item.documentType !== "video"
                            ? _c("b-img", {
                                staticClass: "image_preview",
                                attrs: { src: item.imageUrl || item.imageDocUrl },
                                on: {
                                  click: function ($event) {
                                    return _vm.showImage(
                                      true,
                                      item.imageUrl || item.imageDocUrl,
                                      "image"
                                    )
                                  },
                                },
                              })
                            : (item.imageUrl || item.imageDocUrl) && item.documentType === "video"
                            ? _c("VideoPreview", {
                                attrs: {
                                  videoUrl: item.imageUrl || item.imageDocUrl,
                                  documentType: "video",
                                },
                              })
                            : _vm._e(),
                          _c("div", { staticClass: "last-seen-time" }, [
                            _vm._v(" " + _vm._s(item.createdTime) + " "),
                          ]),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ])
              : _c("div", { staticClass: "chat-text-rrr" }, [
                  _c(
                    "div",
                    { staticClass: "border rounded text-chat p-1 m-1" },
                    [
                      _c("div", [_vm._v(_vm._s(item.message))]),
                      item.imageUrl && item.documentType !== "video"
                        ? _c("b-img", {
                            staticClass: "image_preview",
                            attrs: { src: item.imageUrl },
                            on: {
                              click: function ($event) {
                                return _vm.showImage(
                                  true,
                                  item.imageUrl,
                                  "image"
                                )
                              },
                            },
                          })
                        : item.imageUrl && item.documentType === "video"
                        ? _c("VideoPreview", {
                            attrs: {
                              videoUrl: item.imageUrl,
                              documentType: "video",
                            },
                          })
                        : _vm._e(),
                      _c("div", { staticClass: "last-seen-time" }, [
                        _vm._v(_vm._s(item.createdTime)),
                      ]),
                    ],
                    1
                  ),
                ]),
          ])
        }),
        0
      ),
      _c("div", { staticClass: "mr-1 ml-1 mt-2 pb-1 chat-outer" }, [
        _c("div", { staticClass: "custom-file-outer" }, [
          _c(
            "div",
            { staticClass: "img-input" },
            [
              _c("b-form-textarea", {
                ref: "messageTextarea",
                staticClass: "no-border",
                attrs: {
                  "max-rows": "1",
                  "no-resize": "",
                  rows: "1",
                  placeholder: _vm.$t("orderCreated.TypeMessage"),
                },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.send($event)
                  },
                },
                model: {
                  value: _vm.message,
                  callback: function ($$v) {
                    _vm.message = $$v
                  },
                  expression: "message",
                },
              }),
              _vm.picture && _vm.fileType === "image"
                ? _c("b-img", {
                    staticStyle: {
                      "max-height": "80px",
                      "max-width": "80px",
                      margin: "3px",
                    },
                    attrs: { src: _vm.picture, alt: "Selected Image" },
                  })
                : _vm._e(),
              _vm.picture && _vm.fileType === "video"
                ? _c("VideoPreview", {
                    attrs: { videoUrl: _vm.picture, documentType: "video" },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "send-btn" },
            [
              _c(
                "b-link",
                [
                  _c("Gallery", {
                    staticClass: "mr-1",
                    attrs: { size: "20" },
                    on: { click: _vm.openImagePicker },
                  }),
                ],
                1
              ),
              _c(
                "b-link",
                [
                  _c("Send", {
                    staticClass: "default-send",
                    class: { primary_send: _vm.message || _vm.imageDocUrl },
                    on: { click: _vm.send },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("input", {
        ref: "fileInput",
        staticStyle: { display: "none" },
        attrs: { type: "file", accept: "image/*,image/jpeg,image/png,image/webp,image/gif" },
        on: { change: _vm.handleHiddenFileInputChange },
      }),
      _c("ImagePreview", {
        attrs: {
          showPop: _vm.showDocumentPreviewModal,
          onModalHidden: _vm.showImage,
          url: _vm.url,
          documentType: _vm.type,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/@core/components/chat/Message.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import assets_rashi_coin_copy_svg from '@/assets/rashi-coin/copy.svg';
import assets_rashi_coin_Verify_symbol_svg from '@/assets/rashi-coin/Verify-symbol.svg';
import assets_rashi_coin_silver_svg from '@/assets/rashi-coin/silver.svg';
import assets_rashi_coin_platinum_svg from '@/assets/rashi-coin/platinum.svg';
import assets_rashi_coin_filled_thumb_svg from '@/assets/rashi-coin/filled-thumb.svg';
import assets_rashi_coin_Separator_margin_svg from '@/assets/rashi-coin/Separator_margin.svg';
import assets_rashi_coin_send_svg from '@/assets/rashi-coin/send.svg';
import assets_rashi_coin_image_svg from '@/assets/rashi-coin/image.svg';
import core_components_chat_Message_vue from '@core/components/chat/Message.vue';
import core_components_toastification_ToastificationContent_vue from '@core/components/toastification/ToastificationContent.vue';
import libs_api_api from '@/libs/api/api';
import utils_constants from '@/utils/constants';
import * as vuex from 'vuex';
import moment from 'moment';
import layouts_components_ImagePreview_vue from '@/layouts/components/ImagePreview.vue';
import layouts_components_VideoPreview_vue from '@/layouts/components/VideoPreview.vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















export default ({
  render,
  staticRenderFns,
  components: {
    BCard: bootstrapvue["BCard"],
    BContainer: bootstrapvue["BContainer"],
    BAvatar: bootstrapvue["BAvatar"],
    BButton: bootstrapvue["BButton"],
    BRow: bootstrapvue["BRow"],
    BCol: bootstrapvue["BCol"],
    BLink: bootstrapvue["BLink"],
    Copy: assets_rashi_coin_copy_svg,
    Verify: assets_rashi_coin_Verify_symbol_svg,
    Silver: assets_rashi_coin_silver_svg,
    Platinum: assets_rashi_coin_platinum_svg,
    Send: assets_rashi_coin_send_svg,
    Gallery: assets_rashi_coin_image_svg,
    ChatMessage: core_components_chat_Message_vue,
    FilledThumb: assets_rashi_coin_filled_thumb_svg,
    Greenline: assets_rashi_coin_Separator_margin_svg,
    BInputGroup: bootstrapvue["BInputGroup"],
    BFormGroup: bootstrapvue["BFormGroup"],
    BIcon: bootstrapvue["BIcon"],
    BForm: bootstrapvue["BForm"],
    BFormInput: bootstrapvue["BFormInput"],
    BInputGroupPrepend: bootstrapvue["BInputGroupPrepend"],
    BInputGroupAppend: bootstrapvue["BInputGroupAppend"],
    BImg: bootstrapvue["BImg"],
    BFormFile: bootstrapvue["BFormFile"],
    BFormTextarea: bootstrapvue["BFormTextarea"],
    ImagePreview: layouts_components_ImagePreview_vue,
    BFormTextarea: bootstrapvue["BFormTextarea"],
    VideoPreview: layouts_components_VideoPreview_vue
  },
  props: {
    counterUserData: {
      type: Object,
      isRequired: false,
      default: () => {}
    }
  },
  data() {
    return {
      intervalId: null,
      lastFetchTime: null,
      adOrderChatList: [],
      message: "",
      picture: null,
      imageDocUrl: null,
      name: "",
      userLevel: "",
      showDocumentPreviewModal: false,
      url: "",
      type: "",
      page: 1,
      size: 10,
      apiCallTimerFlag: true,
      oldMessage: "",
      oldPicture: "",
      oldImageDocUrl: "",
      fileType: ""
    };
  },
  computed: {
    ...vuex.mapState("user", ["user"])
  },
  watch: {
    counterUserData(newVal) {
      this.setData();
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.setData();
      this.getOrderMessage();
      this.intervalId = setInterval(this.getOrderMessage, utils_constants["messageInterval"] * 1000);
    }
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    handleScroll() {
      this.apiCallTimerFlag = true;
      const scrollContainer = this.$refs.questionBox;
      const scrollOffset = scrollContainer.scrollHeight - scrollContainer.scrollTop - 1;
      const containerHeight = scrollContainer.clientHeight;
      if (scrollOffset < containerHeight && this.apiCallTimerFlag) {
        this.page++;
        this.apiCallTimerFlag = false;
        this.getOrderMessageScroll();
      }
      setTimeout(() => {
        this.apiCallTimerFlag = true;
      }, 800);
    },
    showImage(flag, url, type) {
      this.showDocumentPreviewModal = flag;
      if (flag) {
        this.url = url;
        this.type = type;
      } else {
        this.url = "";
        this.type = "";
      }
    },
    async setData() {
      if (this.counterUserData && this.counterUserData.id) {
        this.name = this.counterUserData.name || this.counterUserData.email;
        this.userLevel = this.counterUserData.userLevel;
      }
    },
    openImagePicker() {
      this.$refs.fileInput.click();
      this.$refs.messageTextarea.focus();
    },
    handleHiddenFileInputChange(event) {
      const file = event.target.files[0];
      if (file) {
        if (!file.type || !file.type.startsWith("image/")) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: this.$t("Errors.UnsupportedFileType") || "Only image files are allowed",
              icon: "EditIcon",
              variant: "danger"
            }
          });
          event.target.value = "";
          return;
        }
        const maxFileSize = utils_constants["sizeLimit"] * 1024 * 1024;
        if (file.size >= maxFileSize) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: this.$t("Errors.UnsupportedFileSize", {
                limit: utils_constants["sizeLimit"]
              }),
              icon: "EditIcon",
              variant: "danger"
            }
          });
          event.target.value = "";
          return;
        }
        const reader = new FileReader();
        this.imageDocUrl = null;
        this.picture = "";
        reader.onload = e => {
          this.fileType = "image";
          this.imageDocUrl = file;
          this.picture = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    dateFormat(dateTime) {
      if (!dateTime) return "";
      const str = String(dateTime).trim();
      const cleanDate = str.endsWith("Z") ? str : `${str}Z`;
      const m = moment(cleanDate);
      if (m.isValid()) {
        return m.format("HH:mm a");
      }
      const mRaw = moment(str);
      return mRaw.isValid() ? mRaw.format("HH:mm a") : "";
    },
    clearData() {
      this.oldMessage = this.message;
      this.oldPicture = this.picture;
      this.oldImageDocUrl = this.imageDocUrl;
      this.message = "";
      this.picture = null;
      this.imageDocUrl = null;
    },
    async send() {
      try {
        this.message = this.message.trim();
        if (this.message || this.imageDocUrl) {
          const formData = new FormData();
          this.$route.params.id && formData.append("orderId", this.$route.params.id);
          this.message && formData.append("message", this.message);
          this.imageDocUrl && formData.append("imageDocUrl", this.imageDocUrl);
          const res = await new libs_api_api().api({
            method: "post",
            url: "p2p/order/message"
          }, formData, {});
          this.clearData();
          if (res && res.result && res.result.requestStatus == "SUCCESS") {
            this.lastFetchTime = null;
            await this.getOrderMessage(true);
          } else if (res && res.error && res.error.message) {
            this.message = this.oldMessage;
            this.picture = this.oldPicture;
            this.imageDocUrl = this.oldImageDocUrl;
            this.$toast({
              component: core_components_toastification_ToastificationContent_vue,
              props: {
                title: res.error.message,
                icon: "EditIcon",
                variant: "danger"
              }
            });
          }
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    },
    scrollToBottom() {
      this.$nextTick(function () {
        setTimeout(() => {
          var container = this.$refs.questionBox;
          container.scrollTo({
            top: 0,
            behavior: "smooth"
          });
        }, 10);
      });
    },
    async getOrderMessage(userMessage) {
      try {
        if (this.$route.params.id) {
          const res = await new libs_api_api().api({
            method: "GET",
            url: `p2p/order/messages/${this.$route.params.id}`
          }, {
            lastFetchTime: this.lastFetchTime || undefined
          }, {});
          if (res && res.adOrderChatList && res.adOrderChatList.length) {
            let adOrderChatList = [];
            for (let i = res.adOrderChatList.length - 1; i >= 0; i--) {
              const msg = res.adOrderChatList[i];
              let docType = "";
              const img = msg.imageUrl || msg.imageDocUrl;
              if (img) {
                if (typeof img === "string" && (img.startsWith("data:image/") || img.startsWith("data:application/octet-stream") || /\.(png|jpe?g|gif|webp|bmp|svg)/i.test(img))) {
                  docType = "image";
                } else if (typeof img === "string" && (img.startsWith("data:video/") || /\.(mp4|webm|mov|mkv|avi)/i.test(img))) {
                  docType = "video";
                } else {
                  docType = utils_constants.getFileType(img);
                }
              }
              adOrderChatList.push({
                ...msg,
                imageUrl: img,
                imageDocUrl: img,
                createdTime: this.dateFormat(msg.createdTime),
                documentType: docType
              });
            }
            this.adOrderChatList = adOrderChatList;
            if (userMessage) {
              this.scrollToBottom();
            }
            if (res.adOrderChatList.length) {
              this.lastFetchTime = res.adOrderChatList[res.adOrderChatList.length - 1].createdTime;
            } else {
              this.lastFetchTime = new Date().toISOString().split("Z")[0];
            }
          } else if (res && res.error && res.error.message) {
            if (res.error.code && res.error.code == "404") {
              if (this.intervalId) {
                clearInterval(this.intervalId);
              }
              return;
            }
            this.$toast({
              component: core_components_toastification_ToastificationContent_vue,
              props: {
                title: res.error.message,
                icon: "EditIcon",
                variant: "danger"
              }
            });
          }
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    },
    async getOrderMessageScroll() {
      try {
        if (this.$route.params.id) {
          const res = await new libs_api_api().api({
            method: "GET",
            url: `p2p/order/messages/${this.$route.params.id}`
          }, {
            page: this.page,
            size: this.size
          }, {});
          if (res && res.adOrderChatList && res.adOrderChatList.length) {
            let adOrderChatList = [];
            for (let i = res.adOrderChatList.length - 1; i >= 0; i--) {
              const msg = res.adOrderChatList[i];
              let docType = "";
              const img = msg.imageUrl || msg.imageDocUrl;
              if (img) {
                if (typeof img === "string" && (img.startsWith("data:image/") || img.startsWith("data:application/octet-stream") || /\.(png|jpe?g|gif|webp|bmp|svg)/i.test(img))) {
                  docType = "image";
                } else if (typeof img === "string" && (img.startsWith("data:video/") || /\.(mp4|webm|mov|mkv|avi)/i.test(img))) {
                  docType = "video";
                } else {
                  docType = utils_constants.getFileType(img);
                }
              }
              adOrderChatList.push({
                ...msg,
                imageUrl: img,
                imageDocUrl: img,
                createdTime: this.dateFormat(msg.createdTime),
                documentType: docType
              });
            }
            this.adOrderChatList = adOrderChatList;
          } else if (res && res.error && res.error.message) {
            if (res.error.code && res.error.code == "404") {
              if (this.intervalId) {
                clearInterval(this.intervalId);
              }
              return;
            }
            this.$toast({
              component: core_components_toastification_ToastificationContent_vue,
              props: {
                title: res.error.message,
                icon: "EditIcon",
                variant: "danger"
              }
            });
          }
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    }
  }
});

//# sourceURL=webpack:///./src/@core/components/chat/Message.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
.trusted-rudra {
  height: calc(100vh - 230px);
}[dir] .trusted-rudra {
  background-color: #fff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 0;
}
[dir] .trusted-rudra .upper-right-column {
  background-color: rgba(141, 197, 64, 0.12);
}
.trusted-rudra .last-seen-time {
  display: flex;
  justify-content: flex-end;
  color: #48515d;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
}
[dir] .trusted-rudra .last-seen-time {
  margin-top: 10px;
}
[dir=ltr] .trusted-rudra .last-seen-time {
  margin-left: 20px;
}
[dir=rtl] .trusted-rudra .last-seen-time {
  margin-right: 20px;
}
.trusted-rudra .positive-feedback {
  max-width: 60%;
  position: relative;
}
[dir] .trusted-rudra .positive-feedback {
  border-radius: 8px;
  background: #f5f5f5;
}
.trusted-rudra .positive-feedback:after {
  content: "";
  position: absolute;
  top: 15px;
  width: 0;
  height: 0;
}
[dir] .trusted-rudra .positive-feedback:after {
  border: 9px solid transparent;
  margin-top: 0px;
}
[dir=ltr] .trusted-rudra .positive-feedback:after {
  left: 0;
  border-right-color: #f5f5f5;
  border-left: 0;
  margin-left: -9px;
}
[dir=rtl] .trusted-rudra .positive-feedback:after {
  right: 0;
  border-left-color: #f5f5f5;
  border-right: 0;
  margin-right: -9px;
}
.trusted-rudra .image_preview {
  max-height: 200px;
  max-width: 100%;
}
.trusted-rudra .default-send {
  opacity: 0.4;
  stroke: #1c1c1c;
}
.trusted-rudra .primary_send {
  opacity: 1;
}
.trusted-rudra .primary_send path {
  fill: #8dc540;
  stroke: #8dc540;
}
.msg-scrolable {
  max-height: calc(100vh - 381px);
  min-height: calc(100vh - 381px);
}
[dir] .msg-scrolable {
  transform: scaleY(-1);
}
[dir] .msg-scrolable .scroll-msg {
  transform: scaleY(-1);
}
.msg-scrolable.img-uploaded {
  min-height: calc(100vh - 457px) !important;
  max-height: calc(100vh - 457px) !important;
}
.text-chat {
  width: fit-content;
  max-width: 60%;
  height: fit-content;
  word-break: break-all;
  position: relative;
}
[dir=ltr] .text-chat {
  margin-left: auto !important;
}
[dir=rtl] .text-chat {
  margin-right: auto !important;
}
.text-chat:after {
  content: "";
  position: absolute;
  top: 5px;
  width: 0;
  height: 0;
}
[dir] .text-chat:after {
  border: 9px solid transparent;
  margin-top: 0px;
}
[dir=ltr] .text-chat:after {
  right: 0;
  border-left-color: #f5f5f5;
  border-right: 0;
  margin-right: -9px;
}
[dir=rtl] .text-chat:after {
  left: 0;
  border-right-color: #f5f5f5;
  border-left: 0;
  margin-left: -9px;
}
.chat-text-rrr {
  justify-content: end;
}
</style>
